import { api } from '@/redux/api/api';
import { DispatchOptimisticPatchHandler } from '@/redux/types/dispatch-optimistic-patch-handler';
import { updatePropertyRecipe } from '@/redux/utils/update-property-recipe';
import { Policy } from '@/types/policy';
import { UpdateAlexaSkillsQueryArg } from '../types/query-arg';

export const dispatchOptimisticPatchUpdateAlexaSkills: DispatchOptimisticPatchHandler<
  UpdateAlexaSkillsQueryArg
> = ({ organisation, alexaSkills }, { dispatch }) => {
  const patch = dispatch(
    api.util.updateQueryData(
      'getPolicies',
      { organisation },
      updatePropertyRecipe<Policy, 'alexaSkills'>('alexaSkills', alexaSkills),
    ),
  );

  return { patch };
};
